import './utils/ajax';
import Form from '../../modules/core/forms/theme/js/Form';
import Utils from '../../modules/utils/utils-js/theme/js/utils/Utils';

declare let Slider;
declare let FB;

class Site {
    public static discover($parent?: JQuery): void {
        Utils.updateElements($parent);
    }

    private static initFB(): void {
        let old = (<any> window).fbAsyncInit;

        (<any> window).fbAsyncInit = () => {
            FB.Event.subscribe('xfbml.ready', function (msg) {
                if (msg.type === 'video') {
                  let my_video_player = msg.instance;
                  my_video_player.unmute();
                }
              });

              old();
        };
    }

    private static initHtml(): void {
        let $inforows = $('.inforow');

        $inforows.each((ix, el) => {
            const $el = $(el);
            const $more = $('.inforow__button--more', $el);
            const $close = $('.js-close', $el);
            const $full = $('.inforow__full', $el);

            $more.click((e) => {
                let $rest = $inforows.not($el);

                $el.addClass('inforow--opened');
                $rest.removeClass('inforow--opened');
            });

            $close.click((e) => {
                $el.removeClass('inforow--opened');
            });
        });

        const $privacy = $('.privacypolicy');

        $('.js-privacy').on('click', (e) => {
            e.preventDefault();

            $privacy.fadeIn();

            $('body').addClass('body--lock');
        });

        $('.js-privacy__close').on('click', (e) => {
            e.preventDefault();

            $privacy.fadeOut();

            $('body').removeClass('body--lock');
        });

        new Slider($('.media__slider'), {
            fixed: true,
            minwidth: 230,
            max: 3
        });

        $('.media__item').each((ix, el) => {
            const $item = $(el);
            let played = false;

            $item.on('click', function (e) {
                if ($item.data('fbinited')) {
                    return;
                }

                let aa = new Audio('/theme/audio/s.mp3');
                aa.play();

                $item.data('fbinited', true);

                e.preventDefault();

                const $image = $('.media__image', $item);
                const id = $item.data('id');
                const elid = 'fbvideo_' + ix;

                const $video = $('<div id="' + elid + '" class="fb-video" data-href="https://www.facebook.com/facebook/videos/' + id + '" data-width="auto" data-show-text="false" data-autoplay="true"></div>');

                $image.append($video);

                FB.Event.subscribe('xfbml.ready', function(msg) {
                    if (msg.type === 'video' && msg.id == elid && !played) {
                        $item.data('msg', msg);

                        played = true;
                        msg.instance.play();
                    }
                });

                FB.XFBML.parse($item[0]);
            });
        });

        new Slider($('.rowblog__slider'), {
            fixed: true,
            minwidth: 230,
            max: 3
        });

        this.initFB();
    }

    public static init(): void {
        (<any> window).Site = Site;

        Form.initModule();

        $(() => {
            Site.initHtml();

            this.discover();

            $.get('/browserinfo?vw=' + $(window).width() + '&vh=' + $(window).height());
        });

        $(window).on('load', () => {
            $('body').addClass('body--loaded');

            setTimeout(() => {
                $('body').removeClass('body--loading');
                $('body').trigger('pageloaded');
            }, 1000);
        });
    }
}

Site.init();
